// Inventory ticker configuration
// -------------------------------
// Controls the scrolling "available for immediate sale" bar at the bottom
// of the site (see components/InventoryTicker.vue).
//
// To HIDE the ticker entirely (e.g. the last batch sold), set `active: false`.
//   - When inactive, the bar never appears on any page.
//
// To CHANGE what scrolls, edit the `items` array below.
//   - Each item is one headline. Add as many as you like; they scroll in order.
//   - `text` is what shows. Use ` • ` to separate details within a single headline.
//   - `link` is optional. Set it to a URL (e.g. '/trailers') to make the
//     headline clickable, or leave it null for plain text.
//
// Any edit here automatically counts as "the data changed": visitors who
// previously dismissed the ticker will see the new version again.

export const inventoryTicker = {
  active: true,
  items: [
    {
      text: '3-A Sanitary • 8000 gal • Transport • (16+) • Can be modified with a Direct Ship cabinet • Call us for details!',
      link: null,
    },
  ],
}

export default inventoryTicker
